/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Proyek_NInputs */

const en_tut_proyek_n = /** @type {(inputs: Tut_Proyek_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dragging a card on the board really does change the issue's status — everyone sees it, and it is recorded in the issue history.`)
};

const id_tut_proyek_n = /** @type {(inputs: Tut_Proyek_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyeret kartu di papan mengubah status issue-nya sungguhan — perubahan itu terlihat oleh semua orang dan tercatat di riwayat issue.`)
};

/**
* | output |
* | --- |
* | "Dragging a card on the board really does change the issue's status — everyone sees it, and it is recorded in the issue history." |
*
* @param {Tut_Proyek_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_proyek_n = /** @type {((inputs?: Tut_Proyek_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Proyek_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_proyek_n(inputs)
	return en_tut_proyek_n(inputs)
});